import { FaTimes } from "react-icons/fa"
import {IoCheckmarkCircle, IoInformationCircle, IoWarningOutline } from "react-icons/io5"

const Toast = ({variant='info', message, setToastOpen}) => {
    let bgColor , textColor;
    if(variant === 'info'){
        bgColor = 'bg-blue-100';
        textColor = 'text-blue-600';
    }else if(variant === 'error'){
        bgColor = 'bg-red-100';
        textColor = 'text-red-600'
    }else if (variant === 'success') {
        bgColor = 'bg-green-100';
        textColor = 'text-green-600'
    }
    return (    
        <div className={`toast-wrapper ${bgColor}`}>
            <div>
                {variant === 'info' && <IoInformationCircle className={textColor} />}
                {variant === 'error' && <IoWarningOutline className={textColor} />}
                {variant === 'success' && <IoCheckmarkCircle className={textColor} />}
                <h4 className={`${textColor} ml-2`}>{message}</h4>
            </div>
            <FaTimes className={textColor} onClick={() => setToastOpen(false)} />
        </div>
    )
}

export default Toast;